// utils/columnUtils.js
import React from "react";
import { Box, Chip } from "@mui/material";
import TableActions from "../components/common/TableActions/TableAction"; 

// Common column configurations
// export const createSerialNumberColumn = (width = "50px") => ({
//   name: "S.No.",
//   width:'10px',
//   selector: (row, index, currentPage = 1, pageSize = 10) => 
//     (currentPage - 1) * pageSize + index + 1,
//   // Cell will be handled by DataList component
// });

export const createStatusColumn = (customStyles = null) => {
  const defaultStatusColorMap = {
    pending: "warning",
    approved: "info", 
    rejected: "error",
    active: "success",
    inactive: "default",
  };

  const defaultCustomStyles = {
    active: {
      backgroundColor: "#2e7d32",
      color: "#fff",
      border: "1px solid #1b5e20",
    },
    pending: {
      backgroundColor: "#f9a825", 
      color: "#fff",
      border: "1px solid #f57f17",
    },
    approved: {
      backgroundColor: "#0288d1",
      color: "#fff", 
      border: "1px solid #01579b",
    },
    rejected: {
      backgroundColor: "#c62828",
      color: "#fff",
      border: "1px solid #b71c1c", 
    },
    inactive: {
      backgroundColor: "#9e9e9e",
      color: "#fff",
      border: "1px solid #757575",
    },
  };

  return {
    name: "Status",
    width: "180px",
    sortable: true,
    selector: (row) => row.status,
    cell: (row) => {
      const status = row.status?.toLowerCase();
      const styles = customStyles || defaultCustomStyles;
      
      return (
        <Box display="flex" flexDirection="column">
          <Chip
            label={status?.charAt(0).toUpperCase() + status?.slice(1)}
            sx={{
              mt: 0.5,
              width: "fit-content",
              ...(styles[status] || {}),
            }}
            size="small"
          />
        </Box>
      );
    },
  };
};

export const createActionsColumn = ({
  currentPage,
  basePath = "",
  actions = {},
  onView,
  onEdit,
  onDelete,
  onBlock,
  customActions = [],
  width = "200px"
}) => ({
  name: "Action",
  center: true,
  width,
  cell: (row) => (
    <TableActions
      row={row}
      currentPage={currentPage}
      basePath={basePath}
      actions={actions}
      onView={onView}
      onEdit={onEdit}
      onDelete={onDelete}
      onBlock={onBlock}
      customActions={customActions}
    />
  ),
});

// Common column presets
export const createBasicColumns = (fields) => {
  return fields.map(field => ({
    name: field.label,
    sortable: field.sortable !== false,
    selector: (row) => field.selector ? field.selector(row) : row[field.key],
    width: field.width,
    cell: field.cell,
  }));
};

// Helper to create complete column set
export const createColumnSet = ({
  basicFields = [],
  includeSerialNumber = true,
  includeStatus = true,
  includeActions = true,
  currentPage = 1,
  basePath = "",
  actionConfig = {},
  statusConfig = {},
  pageSize = 10,
}) => {
  const columns = [];

  // Add serial number column
  if (includeSerialNumber) {
      columns.push({
      name: "Sr. No",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "80px",
    //   center: true,
    });
  }

  // Add basic columns
  columns.push(...createBasicColumns(basicFields));

  // Add status column
  if (includeStatus) {
    columns.push(createStatusColumn(statusConfig.customStyles));
  }

  // Add actions column
  if (includeActions) {
    columns.push(createActionsColumn({
      currentPage,
      basePath,
      ...actionConfig,
    }));
  }

  return columns;
};